namespace $.$$ {
	export class $shm_textarea_code_view extends $.$shm_textarea_code_view {
		@ $mol_mem
		text_lines() {
			// Native textarea normalizes CRLF and CR to LF before layout/selection.
			// Match that representation without rewriting the persisted source.
			return ( this.text() ?? '' ).split( /\r\n?|\n/ )
		}
	}
}
